module.exports = __webpack_public_path__ + "static/media/SF_bm_primaerlogo_innlandet_pos.a2eb2056.png";